import React from "react";
import Text from "./textElem";
// import css from "./index.less";
import { getDefaultComponentStyle } from "./utils/defaultStyles";

export default ({
  data,
  getText,
  isStreaming,
  top,
}: {
  data: IMultiElementCombineMsg.ITextElem;
  getText: (text: IMultiElementCombineMsg.IText) => string;
  isStreaming: boolean;
  top?: number;
}) => {
  const { content } = data;
  const style = getDefaultComponentStyle(data);

  return (
    <div className={"sscard-ulTextBox"} style={style}>
      <span
        className={"ulCircle"}
        style={top ? { top: `${top}px` } : {}}
      ></span>
      <Text
        data={{ content: content }}
        getText={getText}
        isStreaming={isStreaming}
      />
    </div>
  );
};
